import { httpRequest } from "../../http";

export class CommandGetFontCss {
    async run(family: string, weight: number, italic: boolean): Promise<string> {
        const url =
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/fonts/css/` +
            `${encodeURIComponent(family)}/${weight}/?italic=${italic}`;
        try {
            const response = await httpRequest<string>(url, { method: "GET", responseType: "text" });
            return response;
        } catch (error) {
            console.error("Error fetching font CSS:", error);
            throw error;
        }
    }
}
